const initialState: any = {
  dateTime: {},
};
const DateTime = (state = initialState, action: any) => {
  switch (action.type) {
    case 'Date_Time':
      return {
        ...state,
        dateTime: action?.DateTime,
      };
    default:
      return state;
  }
};

export default DateTime;
